import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Angular2TokenService } from 'angular2-token'
import { Observable } from "rxjs/Observable";
import { TutorAllocation } from "@models/tutor-allocation";
import { TutorTimeslots } from "@models/tutor-timeslots";

@Injectable()
export class TutorAllocationService {

  private tutorAllocationsUrl: string = 'tutor_allocations';

  constructor(
    private http: Angular2TokenService,
  ) {}

  index(): Observable<TutorAllocation[]> {
    return this.http.get(this.tutorAllocationsUrl)
      .map((res: Response) => res.json().map((ta: any) => TutorAllocation.clone(ta)))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  create(ta: TutorAllocation): Observable<TutorAllocation> {
    return this.http.post(this.tutorAllocationsUrl, ta.serializeForRails())
      .map((res: Response) => TutorAllocation.clone(res.json()))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  update(ta: TutorAllocation): Observable<TutorAllocation> {
    return this.http.put(`${this.tutorAllocationsUrl}/${ta.id}`, ta.serializeForRails())
      .map((res: Response) => TutorAllocation.clone(res.json()))
      .catch((error: Response) => Observable.throw(error.json()))
  }

  timeslots(params: any): Observable<TutorTimeslots[]> {
    return this.http.get("someurl")
      .map((res: Response) => res.json().map((t: any) => TutorTimeslots.clone(t)))
      .catch((error: Response) => Observable.throw(error.json()))
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/services/tutor-allocation.ts